export enum NativeInvoicePaymentMethod {
    CARD = "card",
    ACH = "ach",
}

export const NATIVE_INVOICE_DEFAULT_PAYMENT_METHODS: NativeInvoicePaymentMethod[] =
    [NativeInvoicePaymentMethod.CARD];

// Wallets (Apple Pay, Google Pay) ride on card, so the only supported sets are
// card and card + ach.
export function isSupportedNativeInvoicePaymentMethods(
    methods: readonly NativeInvoicePaymentMethod[],
): boolean {
    return (
        methods.includes(NativeInvoicePaymentMethod.CARD) &&
        new Set(methods).size === methods.length
    );
}

export function areSameNativeInvoicePaymentMethods(
    left: readonly NativeInvoicePaymentMethod[],
    right: readonly NativeInvoicePaymentMethod[],
): boolean {
    return (
        left.length === right.length &&
        left.every((method) => right.includes(method))
    );
}
